import { createApp } from 'vue';
import App from './App.vue';
import './components/mindmap/style.css';
import './style.css';

createApp(App).mount('#app');
